module.exports = __webpack_public_path__ + "img/logo2.de724e8e.png";